import queryString from 'query-string';
export var checkSearchQuery = function (key, value) {
    var windowSearch = window.location.search;
    return (queryString.parse(windowSearch) &&
        queryString.parse(windowSearch)[key] === value);
};
